import { setActiveAddLayerDropdownAction as setActiveAddLayerDropdownOperation } from 'editor/src/store/app/slice';

export default setActiveAddLayerDropdownOperation;
